import { ICTask } from './Interfaces';

export class MergefloColors {
  getUserColors(name: string): string {
    let firstLetter = name !== '' ? name[0] : '';
    firstLetter = firstLetter.toLowerCase();
    switch (firstLetter) {
      case 'a':
        return '#625BA6';
      case 'b':
        return '#8E5BA6';
      case 'c':
        return '#A65B6D';
      case 'd':
        return '#96423D';
      case 'e':
        return '#A6765B';
      case 'f':
        return '#999043';
      case 'g':
        return '#7C923F';
      case 'h':
        return '#618043';
      case 'ı':
        return '#439691';
      case 'i':
        return '#439691';
      case 'j':
        return '#439691';
      case 'k':
        return '#34768B';
      case 'l':
        return '#333D95';
      case 'm':
        return '#372CAB';
      case 'n':
        return '#5F237B';
      case 'o':
        return '#672031';
      case 'ö':
        return '#672031';
      case 'p':
        return '#AB241C';
      case 'r':
        return '#706C1E';
      case 's':
        return '#6B3415';
      case 'ş':
        return '#6B3415';
      case 't':
        return '#7E9C26';
      case 'u':
        return '#3D6C0E';
      case 'v':
        return '#3D6C0E';
      case 'w':
        return '#1A7D77';
      case 'y':
        return '#0D5065';
      case 'z':
        return '#1C2679';

      default:
        return '#372CAB';
    }
  }

  getPlaybookColor(name: string): string {
    switch (name) {
      case 'IMO':
        return '#1C2679';
      case 'Operations':
        return '#7f6a99';
      case 'Tax':
        return '#4417a4';
      case 'Communications':
        return '#C8334E';
      case 'Real Estate':
        return '#af62ab';
      case 'EHS':
        return '#3237BA';
      case 'ESG':
        return '#44BBBB';
      case 'Sales':
        return '#ae4f83';
      case 'Marketing':
        return '#1A7D77';
      case 'Legal':
        return '#EB9633';
      case 'IT':
        return '#E76C64';
      case 'HR':
        return '#C8334E';
      case 'F&A':
        return '#af62ab';
      default:
        return '#1A7D77';
    }
  }

  getTaskColor(dealTaskList: ICTask[], taskDetail: ICTask) {
    const yellow = '#FFAB00';
    const red = '#FF5630';
    const green = '#36B37E';
    if (!taskDetail || !taskDetail.dueDate) {
      return yellow;
    } else if (taskDetail.isCompleted === true) {
      return green;
    } else {
      if (new Date() > new Date(taskDetail.dueDate)) {
        return red;
      } else {
        if (
          dealTaskList.filter(
            i =>
              (i.type === 'risk' || i.type === 'issue') &&
              i.isCompleted !== true &&
              i.parentId === taskDetail.id
          ).length
        ) {
          return yellow;
        } else {
          return green;
        }
      }
    }
  }
}
